import { useRef, useCallback, useEffect } from "react";
import { themeColors } from "../../config";

const ResizeBar = ({
  leftWidth,
  resizeable,
  onResize,
  onFinishResize = () => {},
}) => {
  const x = useRef(0);
  const width = useRef(leftWidth);
  const resizer = useRef();

  useEffect(() => {
    if (resizeable) {
      if (resizer.current) {
        resizer.current.addEventListener("mousedown", resizeMouseDown);
        resizer.current.addEventListener("touchstart", resizeTouchStart);
      }
    } else {
      resizer.current.removeEventListener("mousedown", resizeMouseDown);
      resizer.current.removeEventListener("touchstart", resizeTouchStart);
      window.removeEventListener("mousemove", resizeElement);
      window.removeEventListener("mouseup", closeResizeElement);
      window.removeEventListener("touchmove", touchResizeElement);
      window.removeEventListener("touchend", closeTouchResizeElement);
    }
  }, [resizeable]);

  const resizeElement = useCallback((e) => {
    e = e || window.event;
    e.preventDefault();
    const dx = e.clientX - x.current;
    onResize(width.current + dx);
  }, []);

  const touchResizeElement = useCallback((e) => {
    e = e || window.event;
    const dx = e.touches[0].clientX - x.current;
    onResize(width.current + dx);
  }, []);

  const closeResizeElement = useCallback((e) => {
    e = e || window.event;
    width.current = width.current + e.clientX - x.current;
    window.removeEventListener("mousemove", resizeElement);
    window.removeEventListener("mouseup", closeResizeElement);
    const iframes = document.getElementsByTagName("iframe");
    for (let f of iframes) {
      f.style.pointerEvents = "auto";
    }
    onFinishResize();
  }, []);

  const closeTouchResizeElement = useCallback((e) => {
    e = e || window.event;
    width.current = width.current + e.changedTouches[0].clientX - x.current;
    window.removeEventListener("touchmove", touchResizeElement);
    window.removeEventListener("touchend", closeTouchResizeElement);
    const iframes = document.getElementsByTagName("iframe");
    for (let f of iframes) {
      f.style.pointerEvents = "auto";
    }
    onFinishResize();
  }, []);

  const resizeMouseDown = useCallback((e) => {
    e = e || window.event;
    x.current = e.clientX;
    window.addEventListener("mousemove", resizeElement);
    window.addEventListener("mouseup", closeResizeElement);
    const iframes = document.getElementsByTagName("iframe");
    for (let f of iframes) {
      f.style.pointerEvents = "none";
    }
  }, []);

  const resizeTouchStart = useCallback((e) => {
    e = e || window.event;
    x.current = e.touches[0].clientX;
    window.addEventListener("touchmove", touchResizeElement);
    window.addEventListener("touchend", closeTouchResizeElement);
    const iframes = document.getElementsByTagName("iframe");
    for (let f of iframes) {
      f.style.pointerEvents = "none";
    }
  }, []);

  return (
    <div
      ref={resizer}
      style={{
        width: 3,
        height: "100%",
        cursor: "col-resize",
        backgroundColor: themeColors.transparentWhite,
      }}
    ></div>
  );
};

export default ResizeBar;
